import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import AxisSpinner from "./AxisSpinner";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";

const MarkOnHold = ({ user, onComplete, close = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasonValid, setRejectReasonValid] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    var valid =
      rejectReason !== null &&
      rejectReason !== undefined &&
      rejectReason.trim().length > 0;
    setRejectReasonValid(valid);
  }, [rejectReason]);

  useEffect(() => {
    const valid = rejectReasonValid;
    setSaveDisabled(!valid);
  }, [rejectReasonValid]);

  const onSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          user_id: user?.id,
          reason: rejectReason,
        },
      };

      const response = await authAxios().post(
        "/api/backoffice/users/mark_on_hold",
        null,
        config,
      );

      if (onComplete !== null && onComplete !== undefined)
        onComplete(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  const rejectReasonChanged = (value) => {
    var text = value.target.value;
    setRejectReason(text.trim());
  };

  return (
    <Fragment>
      <Form onSubmit={onSave}>
        <Form.Group className="mb-3" controlId="formRejectReason">
          <Row>
            <Col xs lg="2">
              <Form.Label>Reason</Form.Label>
            </Col>
            <Col xs lg="4">
              <Form.Control
                type="text"
                onChange={rejectReasonChanged}
                isValid={rejectReasonValid}
                isInvalid={!rejectReasonValid}
                required
              />
              <Form.Control.Feedback type="invalid">
                Need on hold reason for {user?.surname}, {user?.forename}
              </Form.Control.Feedback>
            </Col>
          </Row>
        </Form.Group>

        <ButtonModalFormSaveClose
          saveName={"Save"}
          close={close}
          formSave={onSave}
          loading={saveDisabled}
        />
      </Form>
    </Fragment>
  );
};

export default MarkOnHold;
